import React, { useMemo } from 'react';
import { IConfigComponent, CElementType } from '@ts/ui-models';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import { generateDateColumn, generateGlobalColumns, IDataGridConfig } from '@ts/storybook';

export const defaultConfigComponent: IConfigComponent = {
  defaultId: 'itemTypes',
  componentId: 'itemTypes',
  aclId: 'tsElementType',
  entity: 'itemType',
  fetchURL: '/api/itemTypes',
  crudURL: '/api/v2/itemType',
  mainClass: CElementType,
};

interface ItemTypesProps {
  title?: string;
  configComponent?: IConfigComponent;
  inheritedProps?: any;
}

const ItemTypes = (props: ItemTypesProps) => {
  const { configComponent = defaultConfigComponent } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };
  const getColumns = useMemo((): GridColDef<any>[] => {
    const globalCells = generateGlobalColumns({ ...props, configComponent });
    return [
      globalCells.id(),
      globalCells.name(),
      generateDateColumn({ field: 'createdAt', headerName: 'Created', isSortable: true }, { field: 'createdAt' }),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //From grandpa
      inheritedProps={props.inheritedProps}
    />
  );
};

export default ItemTypes;
